export default __webpack_public_path__ + "static/media/img1.8037fe0c.jpg";